import React from "react";
import { Typography } from "@mui/material";
import { RENTLY_R_ICON_COLOR } from "../../../constant/constant";

export const SectionHeader = ({ IconComponent, title }) => {
  return (
    <Typography
      variant="subtitle1"
      fontWeight="bold"
      sx={{
        pt: 2,
        pb: 2,
        pl: 2,
        display: "flex",
        alignSelf: "anchor-center",
      }}
    >
      <IconComponent sx={{ color: RENTLY_R_ICON_COLOR }} /> &nbsp; {title}
    </Typography>
  );
};
